export default function CTASection() {
  return (
    <section className="py-10 md:py-12 px-4 md:px-8 bg-secondary-950">
      <div className="flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <h2 className="text-background-50 text-lg md:text-xl font-bold mb-1">
            PRONTO PARA REALIZAR SEU PRÓXIMO NEGÓCIO?
          </h2>
          <p className="text-background-400 text-sm">
            Fale com nossos especialistas e encontre a melhor oportunidade para você.
          </p>
        </div>
        <a
          href="#contato"
          className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-md text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-whatsapp-line text-sm"></i>
          </span>
          FALE CONOSCO AGORA
        </a>
      </div>
    </section>
  );
}